import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ApiService} from "../service/api.service";
import {
  empty,
  formatTimeRude,
  indexNotFound,
  isDefined,
  isEmpty,
  nowMillis,
  numFormat,
  routePath,
  sort
} from 'sdv-common';
import {date_time, reload} from '../shared/constants';
import {DealService} from "../service/deal.service";
import {Deal} from "../model/deal.model";
import {FolderService} from "../service/folder.service";
import {Folder} from "../model/folder.model";
import {DealComponent} from "../deal/deal.component";
import {CookieService} from "ngx-cookie-service";
import {ModalComponent} from "../modal/modal.component";
import {TranslateService} from "@ngx-translate/core";
import {AccountService} from "../service/account.service";
import {Account} from "../model/account.model";
import {DealGroup} from "../model/deal-group.model";
import {customSort} from "../../../../lib/dist/sdv-common";

@Component({
  selector: 'app-deals',
  templateUrl: './deals.component.html',
  styleUrls: ['./deals.component.scss']
})
export class DealsComponent implements OnInit {

  @ViewChild(DealComponent) d: DealComponent;
  @ViewChild('od') outDeal: ModalComponent;

  colors = [{
    name: 'Default',
    color: ''
  }, {
    name: 'Blue',
    color: '#00bcf2'
  }, {
    name: 'Green',
    color: '#47d041'
  }, {
    name: 'Orange',
    color: '#ff8c00'
  }, {
    name: 'Purple',
    color: '#8764b8'
  }, {
    name: 'Red',
    color: '#e74856'
  }, {
    name: 'Yellow',
    color: '#fff100'
  }, {
    name: 'Pink',
    color: '#ffc0cb'
    // }, {
    //   name: 'Custom',
    //   color: 'open color picker and select what you need'
  }];

  masterCheckbox = false;

  expandFavorites = true;
  expandAccounts = false;
  expandFolders = true;
  sortConfig = {
    field: 'profit',
    direction: 'asc',
  };
  search = '';
  account = {
    error: '',
    address: '',
    name: ''
  };
  folder = {
    error: '',
    name: ''
  };
  filterConfig = {
    favorites: true,
    increased: true,
    decreased: true,
    pinned: true,
    hasComment: true,
    inOrder: true,
    closed: false,
    hidden: false
  };
  time: {};

  dateFormat: string = date_time;
  rudePriceFormat: string = '1.2-2';
  softPriceFormat: string = '1.2-10';

  constructor(public apiService: ApiService,
              public accountService: AccountService,
              public cookieService: CookieService,
              public dealService: DealService,
              public folderService: FolderService,
              public translate: TranslateService) {
    if (this.apiService.isAnonymous()) {
      reload(routePath.login);
    }
  }

  ngOnInit() {
    const sortConfig = this.cookieService.get('sortConfig');
    if (sortConfig) {
      this.sortConfig = JSON.parse(decodeURIComponent(sortConfig));
    }

    const filterConfig = this.cookieService.get('filterConfig');
    if (filterConfig) {
      this.filterConfig = JSON.parse(decodeURIComponent(filterConfig));
    }

    this.translate.get('app.time')
      .subscribe(time => {
        this.time = time;
      });

    if (this.apiService.getParam('$action') === 'add-deal') {
      this.addDeal();
    }
  }

  now() {
    return nowMillis();
  }

  addDeal() {
    if (!this.d) {
      setTimeout(() => this.addDeal(), 100);
      return;
    }
    let params = {'$action': 'add-deal'};
    let folder = this.apiService.getParam("$folder");
    if (folder) {
      params['$folder'] = folder;
    }
    if (folder === 'new' || folder === 'all') {
      folder = null;
    }
    let account = this.apiService.getParam("$account");
    if (account) {
      params['$account'] = account;
    }
    this.apiService.setParams(params, empty);
    this.d.setDeal('add', {
      attributes: [],
      direction: 'LONG',
      toToken: {
        contract: '0x55d398326f99059ff775485246999027b3197955', // contract for USDT
        symbol: 'USDT'
      },
      fromToken: {},
      created: +new Date(),
      account_id: account || this.accountService.getAccounts().length === 0 ? account : this.accountService.getAccounts()[0].id,
      folder_id: folder
    });
  }

  abs(num) {
    return Math.abs(num);
  }

  masterCheckboxClick() {
    this.masterCheckbox = !this.masterCheckbox;
    Array.prototype.concat.apply([], this.getGroups().map(g => g.deals))
      .forEach(d => d.selected = this.masterCheckbox);
  }

  isFavoriteSelectedContainer() {
    let id = this.apiService.getParam('$folder');
    if (id) {
      for (const folder of this.folderService.getFolders('all')) {
        if (folder.id === id) {
          return this.folderService.getAttributeValue(folder.attributes, this.folderService.favoriteAttrId, false);
        }
      }
    }
    return false;
  }

  getSelectedContainer() {
    let id = this.apiService.getParam('$folder');
    if (id) {
      for (const folder of this.folderService.getFolders('all')) {
        if (folder.id === id) {
          return folder;
        }
      }
    }
    id = this.apiService.getParam('$account');
    if (id) {
      for (const account of this.accountService.getAccounts()) {
        if (account.id === id) {
          return account;
        }
      }
    }
    return this.folderService.getFolders('all')[0];
  }

  hasSelectedAttr(attrId: number) {
    return Array.prototype.concat.apply([], this.getGroups().map(g => g.deals))
      .filter(n => n.selected && this.d.getAttributeValue(n.attributes, attrId, false))
      .length > 0;
  }

  getSelectedDealCount() {
    return Array.prototype.concat.apply([], this.getGroups().map(g => g.deals))
      .filter(d => d.selected).length;
  }

  openDeal(deal: Deal) {
    Array.prototype.concat.apply([], this.getGroups().map(g => g.deals))
      .forEach(d => d.selected = false);
    deal.selected = true;
    this.apiService.setParams({
      '$action': 'edit-deal',
      '$deal': deal.id
    });
    this.d.setDeal('edit', deal);
  }

  openFolder(f: Folder) {
    this.search = '';
    Array.prototype.concat.apply([], this.dealService.getGroups().map(g => g.deals))
      .forEach(n => n.selected = false);
    this.apiService.setParams({
      '$folder': f.id
    }, '');
    this.d.setDeal('none');
  }

  openAccount(e: Account) {
    this.search = '';
    Array.prototype.concat.apply([], this.dealService.getGroups().map(g => g.deals))
      .forEach(n => n.selected = false);
    this.apiService.setParams({
      '$account': e.id
    }, '');
    this.d.setDeal('none');
  }

  getGroups(): DealGroup[] {
    if (!isDefined(this.d)) {
      return [];
    }
    let groups: DealGroup[] = this.dealService.getGroups();
    let fId = this.apiService.getParam("$folder");
    let aId = this.apiService.getParam("$account");
    if (fId && fId !== 'all') {
      if (fId === 'new') {
        fId = '';
      }
      groups = groups.filter(g => g.deals[0].folder_id === fId);
    } else if (aId) {
      groups = groups.filter(g => g.deals[0].account_id === aId);
    }

    groups = sort(groups, this.sortConfig.field, this.sortConfig.direction === 'desc');
    groups = customSort(groups, (i1, i2) => {
      let val1 = i1.deals.filter(d => this.d.getAttributeValue(d.attributes, this.dealService.pinnedAttrId)).length;
      let val2 = i2.deals.filter(d => this.d.getAttributeValue(d.attributes, this.dealService.pinnedAttrId)).length;
      if (val1 > val2) {
        return -1;
      }
      if (val1 < val2) {
        return 1;
      }
      return 0;
    });
    // groups = ascSort(groups, 'in_order');
    if (!this.filterConfig.increased) {
      groups = groups.filter(g => g.profit() <= 0);
    }
    if (!this.filterConfig.decreased) {
      groups = groups.filter(g => g.profit() >= 0);
    }
    if (!this.filterConfig.favorites) {
      groups = groups.filter(g =>
        Array.prototype.concat.apply([], g.deals)
          .filter(d => this.d.getAttributeValue(d.attributes, this.dealService.favoriteAttrId))
          .length < g.deals.length
      );
    }
    if (!this.filterConfig.pinned) {
      groups = groups.filter(g =>
        Array.prototype.concat.apply([], g.deals)
          .filter(d => this.d.getAttributeValue(d.attributes, this.dealService.pinnedAttrId))
          .length < g.deals.length
      );
    }
    if (!this.filterConfig.hasComment) {
      groups = groups.filter(g =>
        Array.prototype.concat.apply([], g.deals)
          .filter(d => this.d.getAttributeValue(d.attributes, this.dealService.commentAttrId))
          .length < g.deals.length
      );
    }
    if (!this.filterConfig.inOrder) {
      groups = groups.filter(g =>
        Array.prototype.concat.apply([], g.deals)
          .filter(d => this.d.getAttributeValue(d.attributes, this.dealService.inOrderAttrId))
          .length < g.deals.length
      );
    }
    // if (!this.filterConfig.closed) {
    //   deals = deals.filter(n => !n.closed);
    // }
    if (!this.filterConfig.hidden) {
      groups = groups.filter(g =>
        Array.prototype.concat.apply([], g.deals)
          .filter(d => this.d.getAttributeValue(d.attributes, this.dealService.hiddenAttrId))
          .length < g.deals.length
      );
    }
    if (this.search) {
      if (this.search.indexOf('%') != indexNotFound ||
        this.search.indexOf('>') != indexNotFound ||
        this.search.indexOf('<') != indexNotFound) {
        // let percentage = this.search.split('&&');
        // if (percentage.length === 1) {
        //   let percent = percentage[0].trim();
        //   let val = parseFloat(percent.substr(1));
        //   if (percent.startsWith('>')) {
        //     deals = deals.filter(n => ((n.last_price / n.price) * 100) - 100 > val);
        //   } else if (percent.startsWith('<')) {
        //     deals = deals.filter(n => ((n.last_price / n.price) * 100) - 100 < val);
        //   } else {
        //     debugger;
        //   }
        // } else if (percentage.length === 2) {
        //   let percent1 = percentage[0].trim();
        //   let val1 = parseFloat(percent1.substr(1));
        //
        //   let percent2 = percentage[1].trim();
        //   let val2 = parseFloat(percent2.substr(1));
        //
        //   if (percent1.startsWith('>') && percent2.startsWith('>')) {
        //     deals = deals.filter(n => ((n.last_price / n.price) * 100) - 100 > val1 && ((n.last_price / n.price) * 100) - 100 > val2);
        //   } else if (percent1.startsWith('<') && percent2.startsWith('<')) {
        //     deals = deals.filter(n => ((n.last_price / n.price) * 100) - 100 < val1 && ((n.last_price / n.price) * 100) - 100 < val2);
        //   } else if (percent1.startsWith('<') && percent2.startsWith('>')) {
        //     deals = deals.filter(n => ((n.last_price / n.price) * 100) - 100 < val1 && ((n.last_price / n.price) * 100) - 100 > val2);
        //   } else if (percent1.startsWith('>') && percent2.startsWith('<')) {
        //     deals = deals.filter(n => ((n.last_price / n.price) * 100) - 100 > val1 && ((n.last_price / n.price) * 100) - 100 < val2);
        //   } else {
        //     debugger;
        //   }
        // } else {
        //   debugger;
        // }
      } else {
        groups = groups.filter(n => n.fromToken().toLowerCase().indexOf(this.search.toLowerCase()) > indexNotFound);
      }
    }
    for (let group of groups) {
      sort(group.deals, 'created', this.sortConfig.direction === 'desc');
    }
    return groups;
  }

  getStat(id, propertyName) {
    let deals: Deal[] = Array.prototype.concat.apply([], this.dealService.getGroups().map(g => g.deals));
    if (id === 'new') {
      id = '';
    }
    if (id != 'all') {
      deals = deals.filter(d => d[propertyName] === id);
    }
    let count = 0;
    let sumInvest = 0;
    let sumProfit = 0;
    for (const deal of deals) {
      sumInvest += deal.price * deal.quantity;
      sumProfit += deal.profit;
      count++;
    }
    return {
      count,
      profit: sumProfit,
      invest: sumInvest
    };
  }

  formatDate(time: number) {
    return new Date(time);
  }
  formatTime(time: number) {
    return formatTimeRude(time);
  }

  changeFilterState(name: string) {
    this.filterConfig[name] = !this.filterConfig[name];
    this.cookieService.set("filterConfig", JSON.stringify(this.filterConfig));
  }

  changeSortFieldState(name: string) {
    this.sortConfig.field = name;
    this.cookieService.set("sortConfig", JSON.stringify(this.sortConfig));
  }

  changeSortDirectionState(direction: string) {
    this.sortConfig.direction = direction;
    this.cookieService.set("sortConfig", JSON.stringify(this.sortConfig));
  }

  attrGroup(group: DealGroup, attrId, flag) {
    for (const deal of group.deals) {
      let attr = this.d.getAttribute(deal.attributes, attrId);
      if (isDefined(attr) && !flag) {
        this.d.attrDelete(deal, attr.id);
      } else if (flag) {
        this.d.attrCreate(deal, attrId, flag);
      }
    }
  }

  hasGroupAttr(group: DealGroup, attrId) {
    for (const deal of group.deals) {
      if (this.d.getAttributeValue(deal.attributes, attrId, false)) {
        return true;
      }
    }
    return false;
  }

  removeGroup(group: DealGroup) {

  }

  shareGroup(group: DealGroup) {
    this.shareDeal({
      price: group.price(),
      profit: group.profit(),
      quantity: group.quantity(),
      direction: group.deals[0].direction,
      last_price: group.deals[0].last_price,
      fromToken: {
        name: group.deals[0].fromToken.name,
        icon: group.deals[0].fromToken.icon,
        symbol: group.deals[0].fromToken.contract,
        contract: group.deals[0].fromToken.contract,
        network_id: group.deals[0].fromToken.network_id,
        exchange_id: group.deals[0].fromToken.exchange_id,
        decimal: group.deals[0].fromToken.decimal,
        description: group.deals[0].fromToken.description,
        // below needed just for suppress error
        id: ''
      },
      toToken: {
        name: group.deals[0].toToken.name,
        icon: group.deals[0].toToken.icon,
        symbol: group.deals[0].toToken.contract,
        contract: group.deals[0].toToken.contract,
        network_id: group.deals[0].toToken.network_id,
        exchange_id: group.deals[0].toToken.exchange_id,
        decimal: group.deals[0].toToken.decimal,
        description: group.deals[0].toToken.description,
        // below needed just for suppress error
        id: ''
      },
      // below needed just for suppress error
      id: '',
      created: 0,
      account_id: '',
      folder_id: '',
      attributes: []
    });
  }

  shareDeal(deal: Deal) {
    let canvas = document.createElement('canvas');
    canvas.width = 500;
    canvas.height = 200;

    let ctx = canvas.getContext('2d');

    ctx.fillStyle = "#333333";
    ctx.font = "30px Arial";
    ctx.fillText(deal.direction + ' ' + deal.fromToken.name + '/' + deal.toToken.name, 10, 40);

    ctx.fillStyle = deal.profit > 0 ? '#00ff00' : '#ff0000';
    ctx.fillText((deal.profit > 0 ? '+' : '') + (((deal.last_price / deal.price) * 100) - 100).toFixed(2) + '%', 10, 80);

    ctx.fillStyle = "#333333";
    ctx.fillText('$' + deal.price, 10, 120);

    ctx.fillText('$' + deal.last_price, 10, 160);

    ctx.beginPath();
    ctx.moveTo(0, 170);
    ctx.lineTo(500, 170);
    ctx.stroke();

    ctx.font = "15px Arial";
    ctx.fillText('invest.sdv291.com', 10, 190);

    canvas.toBlob((blob) => window.open(URL.createObjectURL(blob), '_blank'));
  }

  moveToAccount(a: Account) {

  }

  moveTo(f: Folder) {
    // let dealIds = [];
    // for (const deal of this.dealService.getDeals()) {
    //   if (deal.selected) {
    //     dealIds.push(deal.id);
    //   }
    //   for (const d of deal.deals) {
    //     if (d.selected) {
    //       dealIds.push(d.id);
    //     }
    //   }
    // }
    // if (dealIds.length === 0) {
    //   return;
    // }
    // this.apiService.send({
    //   command: 'move_to_folder',
    //   request: {
    //     folderId: f.id,
    //     dealIds: dealIds
    //   }
    // }, (response, headers) => {
    //   response = response.response;
    //   if (!response.error) {
    //     for (const deal of this.dealService.getDeals()) {
    //       if (deal.selected) {
    //         deal.folder_id = f.id
    //       }
    //       for (const d of deal.deals) {
    //         if (d.selected) {
    //           deal.folder_id = f.id
    //           d.folder_id = f.id
    //         }
    //       }
    //     }
    //     return;
    //   }
    // });
  }

  colorDeals(color: string) {
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.selected) {
          let attr = this.d.getAttribute(deal.attributes, this.dealService.colorAttrId);
          if (isDefined(attr)) {
            this.d.attrDelete(deal, attr.id)
              .then(() => {
                if (!isEmpty(color)) {
                  this.d.attrCreate(deal, this.dealService.colorAttrId, color);
                }
              });
          } else if (!isEmpty(color)) {
            this.d.attrCreate(deal, this.dealService.colorAttrId, color);
          }
        }
      }
    }
  }

  attrDeals(flag: boolean, attrId: number) {
    for (const group of this.dealService.getGroups()) {
      for (const deal of group.deals) {
        if (deal.selected) {
          let attr = this.d.getAttribute(deal.attributes, attrId);
          if (isDefined(attr) && !flag) {
            this.d.attrDelete(deal, attr.id);
          } else if (flag) {
            this.d.attrCreate(deal, attrId, flag);
          }
        }
      }
    }
  }

  format(num: number) {
    const result = numFormat(num) + '';
    if (result.match(/\D$/gm) == null) {
      return parseFloat(result).toFixed(2);
    }
    return result;
  }

  isVisible(act) {
    if (document.body.clientWidth < 1000) {
      if (act === 'deal') {
        return this.apiService.getParam('$action') === 'add-deal' || this.apiService.getParam('$action') === 'edit-deal';
      }
      if (act === 'details') {
        return !(this.apiService.getParam('$action') === 'add-deal' || this.apiService.getParam('$action') === 'edit-deal');
      }
    }
    return false;
  }

  getOutOrders() {
    if (!this.outDeal) {
      return [];
    }
    let deal = this.outDeal.get();
    if (!deal) {
      return [];
    }
    return deal.out_order;
  }

  executedOutOrder(outOrder) {
    // let deal = this.outDeal.get();
    // this.apiService.send({
    //   command: 'attr_deal',
    //   request: {
    //     id: deal.id,
    //     attributes: [{
    //       id: outOrder.id,
    //       operation: 'DELETE',
    //       value: 'APPLY',
    //       typeId: 6
    //     }]
    //   }
    // }, (response, headers) => {
    //   response = response.response;
    //   if (!response.error) {
    //     reload('/deals');
    //     return;
    //   }
    // });
  }

  removeOutOrder(outOrder) {
    // let deal = this.outDeal.get();
    // this.apiService.send({
    //   command: 'attr_deal',
    //   request: {
    //     id: deal.id,
    //     attributes: [{
    //       id: outOrder.id,
    //       operation: 'DELETE',
    //       value: 'REMOVE',
    //       typeId: 6
    //     }]
    //   }
    // }, (response, headers) => {
    //   response = response.response;
    //   if (!response.error) {
    //     reload('/deals');
    //     return;
    //   }
    // });
  }

  jsonParse(value) {
    return JSON.parse(value);
  }

  protected readonly isEmpty = isEmpty;

  toggleFavorite() {
    let folderId = this.apiService.getParam('$folder');
    let accountId = this.apiService.getParam('$account');
    if (folderId) {
      let folder = this.folderService.getFolders().find(f => f.id === folderId);
      if (this.isFavoriteSelectedContainer()) {
        this.folderService.attrDelete(folder, this.folderService.getAttribute(folder.attributes, this.folderService.favoriteAttrId).id);
      } else {
        this.folderService.attrCreate(folder, this.folderService.favoriteAttrId, true);
      }
    } else if (accountId) {
      // let account = this.accountService.getFolders().find(a => a.id === accountId);
      // if (this.getSelectedContainer().favorite) {
      //   this.accountService.attrCreate(account, 1, true);
      // } else {
      //   this.accountService.attrDelete(account, 1);
      // }
    } else {
      debugger;
    }
  }

  protected readonly document = document;

  navigationPanel() {
    let nav = document.getElementsByClassName('main-container')[0];
    if (nav.classList.contains('toggled')) {
      nav.classList.remove('toggled');
    } else {
      nav.classList.add('toggled');
    }
  }
}
